module.exports = __webpack_public_path__ + "img/913c8de.png";